export enum Gender {
  Male = 1,
  Female = 2,
  NoAnswer = 3,
  NotBoth = 4,
}
